/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConnectionStatus } from './connectionStatus';

export type GssOccasionPersonTeaserConnectionStatus = ConnectionStatus | null;
